export function TableHeaderIcon({ icon: Icon }) {
  return (
    <span
      className="tw:inline-flex tw:size-8 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:border tw:border-border tw:bg-background tw:text-foreground tw:dark:border-input tw:dark:bg-input/30"
      aria-hidden="true"
      data-slot="table-header-icon"
    >
      <Icon className="tw:size-4" />
    </span>
  );
}
